module.exports = __webpack_public_path__ + "static/media/fotter.ec5eb4c4.svg";